<template>
    <div class="appropriateness-score-pill-wrapper flex items-center">
        <div class="group relative rounded-full w-4 h-4" :class="this.scoreStatus.class">
            <div
                class="absolute w-[250px] left-0 bg-deep-blue text-white rounded px-4 py-3 text-[14px] z-10 transition-all leading-none opacity-0 invisible group-hover:opacity-100 group-hover:visible"
                :class="[labelBottom ? '-bottom-[5px] translate-y-full' : '-top-[5px] -translate-y-full']"
                v-html="this.scoreStatus.description"
            ></div>
        </div>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex';
export default {
    name: "AppropriatenessScorePillComponent",
    props: {
        score: { type: Number, default: null },
        labelBottom: { type: Boolean, default: false },
    },
    components: {},
    computed: {
        // ...mapGetters(["collections"])
    },
    mounted() {
        this.calculateScoreStatus();
    },
    data: function () {
        return {
            scoreStatus: {
                class: "",
                description: "",
            },
        };
    },
    methods: {
        calculateScoreStatus() {
            if (this.score != null && this.score < 20) {
                this.scoreStatus.class = "bg-error";
                this.scoreStatus.description =
                    "<strong>Score:</strong> " +
                    this.score +
                    ".<br /><br /><strong>Status:</strong> Training recommended.";
            } else if (this.score >= 20 && this.score < 50) {
                this.scoreStatus.class = "bg-warning";
                this.scoreStatus.description =
                    "<strong>Score:</strong> " + this.score + ".<br /><br /><strong>Status:</strong> Warning.";
            } else if (this.score >= 50) {
                this.scoreStatus.class = "bg-success";
                this.scoreStatus.description =
                    "<strong>Score:</strong> " + this.score + ".<br /><br /><strong>Status:</strong> Pass.";
            } else {
                this.scoreStatus.class = "bg-grey/20";
                this.scoreStatus.description = "Status: Unknown";
            }
        },
    },
    watch: {
        score() {
            this.calculateScoreStatus();
        },
    },
};
</script>
